import createIcon from '../../createIcon';

/**
 * @component @name Polyline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTZWMTcuMjZMOSAxNC4yNlYxMS4wOUwxMS43IDhIMTZWMkgxMFY2LjlMNy4zIDEwSDNWMTZIOEwxNSAxOS41VjIySDIxVjE2SDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Polyline = createIcon('Polyline', [
  [
    'path',
    {
      d: 'M15 16V17.26L9 14.26V11.09L11.7 8H16V2H10V6.9L7.3 10H3V16H8L15 19.5V22H21V16H15Z',
      key: '1u1jrl',
    },
  ],
]);

export default Polyline;
